import { useEffect } from "react";
import { useLocation } from "@/lib/router-compat";

/**
 * Resets scroll position to the top whenever the route changes.
 * Prevents new pages from opening at the previous page's scroll offset.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use 'auto' (instant) so users don't see a jarring scroll animation
    // when navigating between pages.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};
